:host {
  --grid-template-areas: var(
    --stzh-daterange-grid-template-areas,
    "datefrom datefrom datefrom datefrom"
    "dateto dateto dateto dateto"
    "links links links links"
  );

  --grid-template-columns: var(
    --stzh-daterange-grid-template-columns,
    #{$gridColumns}
  );

  @include mq($from: small) {
    --grid-template-areas: var(
      --stzh-daterange-grid-template-areas,
      "datefrom datefrom dateto dateto"
      "links links links links"
    );
  }

  @include mq($from: medium) {
    --grid-template-areas: var(
      --stzh-daterange-grid-template-areas,
      "datefrom datefrom dateto dateto links links links links"
    );

    --grid-template-columns: var(
      --stzh-daterange-grid-template-columns,
      #{$gridColumnsMedium}
    );
  }
}

.stzh-daterange {
  --stzh-description-min-height: #{$fieldsetDescriptionMinHeight};

  @include gridGutter;
  display: grid;
  align-items: center;
  grid-template-areas: var(--grid-template-areas);
  grid-template-columns: var(--grid-template-columns);
  align-items: start;
  border: none;
  padding: 0;

  &__legend {
    @include visuallyhidden;
  }

  &__datefrom {
    grid-area: datefrom;
  }

  &__dateto {
    grid-area: dateto;
  }

  &__links {
    grid-area: links;
    align-self: center;
  }

  &__links {
    display: flex;
    gap: space('large');
  }
}
